import { LAUNCH_USAGE_TIMEZONE, USAGE_WARN_RATIO } from "@sagot/constants";

/** How much of Lite's monthly launches is used: `warn` from the usual usage warning ratio, `full` when none is left. */
export interface TierUsageView {
  readonly used: number;
  readonly limit: number;
  readonly remaining: number;
  readonly percent: number;
  readonly level: "ok" | "warn" | "full";
}

export function usageView(used: number, limit: number): TierUsageView {
  const safeLimit = Math.max(limit, 1);
  const safeUsed = Math.max(used, 0);
  const percent = Math.min((safeUsed / safeLimit) * 100, 100);
  const level = safeUsed >= safeLimit ? "full" : safeUsed / safeLimit >= USAGE_WARN_RATIO ? "warn" : "ok";
  return { used: safeUsed, limit: safeLimit, remaining: Math.max(safeLimit - safeUsed, 0), percent, level };
}

/** `2026-11-01` (the first day of next month, Asia/Manila) as a date in the reader's language. */
export function resetLabel(resetsOn: string, locale: string): string {
  const parsed = new Date(`${resetsOn}T00:00:00+08:00`);
  if (Number.isNaN(parsed.getTime())) return resetsOn;
  return new Intl.DateTimeFormat(locale, { timeZone: LAUNCH_USAGE_TIMEZONE, year: "numeric", month: "long", day: "numeric" }).format(parsed);
}
